<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Shareholder Meeting',
          to: {
            name: 'ShareholderMeeting'
          }
        },
        { name: 'Create',
          to: {
            name: 'ShareholderMeetingCreate',
          },
        },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>新增Shareholder Meeting</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <ShareholderMeetingCreateEdit></ShareholderMeetingCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ShareholderMeetingCreateEdit from '@/views/I-3__IR-ShareholderMeeting/c/ShareholderMeetingCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    ShareholderMeetingCreateEdit,
  },
  created() {
    this.setShareholderMeeting({
      title: '',
      event_date: '',
      downloads: [],
    });
  },
  computed: {
    ...mapState('shareholderMeeting', ['shareholderMeeting']),
  },
  methods: {
    ...mapActions('shareholderMeeting', ['setShareholderMeeting', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'ShareholderMeeting' });
    },
    saveHandler() {
      this.save(this.shareholderMeeting).then(() => {
        this.$router.push({ name: 'ShareholderMeeting' });
      });
    },
  },
};
</script>

<style></style>
